/* global localData */

window.addEventListener('spectoCmsContentLoaded', () => {
  window.newsFeedEle = document.querySelector('.sc-news-feed');

  if (newsFeedEle) {
    const searchPage = newsFeedEle.classList.contains('search-result-news-feed');

    const sendAjaxHandler = (action, filterBy, sortBy, searchTerm, pageNumber) => {
      const injectedPageId = document.querySelector('.injection').dataset.pageId || null;
      const newsFeedInner = newsFeedEle.querySelector('.news-feed__list-items');
      const newsFeedPagination = newsFeedEle.querySelector('.news-feed__pagination');
      let parameters = '';

      if (searchPage) {
        parameters = `searchTerm=${searchTerm}&filterBy=${filterBy}&sortBy=${sortBy}&pageNumber=${pageNumber}`;
      } else {
        const categoryId = newsFeedEle.querySelector('[data-category-id]').getAttribute('data-category-id');
        const categoryName = newsFeedEle.querySelector('[data-category-name]').getAttribute('data-category-name');

        parameters = `filterBy=${filterBy}&sortBy=${sortBy}&categoryId=${categoryId}&categoryName=${categoryName}`;
      }

      const request = new XMLHttpRequest();
      request.open('POST', localData.siteURL, true);
      request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      request.send(`action=${action}&id=${localData.pageID}&${parameters}&injectionId=${injectedPageId}`);
      request.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          const response = JSON.parse(this.responseText);
          if (response.data.status === 200) {
            const event = new CustomEvent('queryParameter', { detail: response.data.pageLink });
            // window.history.replaceState(null, null, response.data.pageLink);
            newsFeedInner.innerHTML = response.data.posts;
            newsFeedPagination.innerHTML = `<div class="margin : margin--45"></div>${response.data.pagination}` || '';
          }
        }
      };
    };

    // Filter news feed cards
    const filterItems = document.querySelectorAll('.news-feed__filter-item');

    filterItems.forEach((filterItem) => {
      filterItem.addEventListener('click', () => {
        filterItems.forEach((item) => item.classList.remove('is-active'));

        filterItem.classList.add('is-active');
        filterItem.classList.toggle('asc');
        filterItem.classList.toggle('desc');

        const urlParams = new URLSearchParams(window.location.search);
        const searchTerm = urlParams?.get('searchTerm') ?? '';
        const pageNumber = urlParams?.get('pageNumber') ?? '1';

        sendAjaxHandler(searchPage ? 'getPostsDataOnSearchPageNewsFeedFilter' : 'getPostsDataOnNewsFeedFilter', filterItem.classList[3], filterItem.classList[5], searchTerm, pageNumber);
      });
    });

    // On window load change active filter as per url parameter
    window.addEventListener('load', () => {
      const urlParams = new URLSearchParams(window.location.search);
      const filterBy = urlParams.get('filterBy');
      const sortBy = urlParams.get('sortBy');

      if (filterBy && sortBy) {
        filterItems.forEach((item) => item.classList.remove('is-active'));

        const targetElem = newsFeedEle.querySelector(`.${filterBy}`);
        targetElem.classList.add('is-active');
        targetElem.classList.remove('acs');
        targetElem.classList.remove('desc');
        targetElem.classList.add(`${sortBy}`);
      }
    });
  }
});
